import { useRef, useCallback } from 'react'
import type { BlockProps } from '../types.js'
import type { GuestbookEntryPublic } from '@cugumi/shared/schemas'
import { SectionWrapper } from './SectionWrapper.js'
import { GuestbookSampleList } from './guestbook/GuestbookSampleList.js'
import { GuestbookForm } from './guestbook/GuestbookForm.js'
import { GuestbookList } from './guestbook/GuestbookList.js'
import commonStyles from './common.module.css'
import styles from './GuestbookBlock.module.css'

export function GuestbookBlock({ invitation, activeSection, onSectionClick, mode }: BlockProps) {
  const addOptimisticRef = useRef<((entry: GuestbookEntryPublic) => void) | null>(null)

  const handleSubmitSuccess = useCallback((entry: GuestbookEntryPublic) => {
    addOptimisticRef.current?.(entry)
  }, [])

  return (
    <SectionWrapper
      sectionId="guestbook"
      activeSection={activeSection}
      onSectionClick={onSectionClick}
      mode={mode}
      className={commonStyles.section}
    >
      <span className={commonStyles.sectionTitle}>방명록</span>
      <div className={commonStyles.divider} />

      {mode === 'editor' ? (
        <div className={styles.list}>
          <GuestbookSampleList />
        </div>
      ) : (
        <>
          <GuestbookForm
            invitationId={invitation.id}
            onSubmitSuccess={handleSubmitSuccess}
          />
          <GuestbookList
            invitationId={invitation.id}
            onMountAddOptimistic={(fn) => { addOptimisticRef.current = fn }}
          />
        </>
      )}
    </SectionWrapper>
  )
}
